import http from '@/http';

export default {
    list() {
        return http.get('/contracts');
    },
    fetch(id) {
        return http.get(`/contracts/${id}`);
    },
    remove(id) {
        return http.delete(`/contracts/${id}`);
    },
    save(form) {
        return http.post('/contracts', form);
    },
    update(id, form) {
        return http.put(`/contracts/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/contracts.js